// serviceWorkerRegistration.js
// Registers public/service-worker.js, which shows push notifications for the
// field staff app and sends answers from Android notification buttons. It
// caches nothing, so it does not change how the site loads.
export const apiBase = () =>
  (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api').replace(/\/+$/, '');

export const register = () => {
  if (!('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js?api=${encodeURIComponent(apiBase())}`)
      .catch((error) => console.error('Service worker registration failed:', error));
  });
};
